import React from 'react';
import Button from '@amzn/awsui-components-react/polaris/button';

import logo from '../assets/logo-color-dark.svg';
import './Header.css';

interface HeaderProps {
  user?: any;
  onLogout?: () => void;
}

const Header = ({ user, onLogout }: HeaderProps) => {
  return (
    <header className="Header">
      <div className="Header__branding">
        <img src={logo} alt="AWS Training and Certification" />
      </div>
      {user && (
        <div className="Header__logout">
          <Button onClick={onLogout} variant="normal">
            Log out
          </Button>
        </div>
      )}
    </header>
  );
};

export default Header;
